module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('article', {
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.28), rgba(0, 0, 0, 0)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "menu-banner"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('h6', {
    staticStyle: {
      "color": "#000000",
      "font-weight": "bolder"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_category))])]) : _vm._e(), _vm._v(" "), _c('section', {
    attrs: {
      "id": "menu"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/title-detail.png",
      "alt": "title-detail"
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.sellpoint.business_tagline))]), _vm._v(" "), _c('p', {
    staticStyle: {
      "height": "80px",
      "overflow": "hidden",
      "text-overflow": "ellipsis"
    }
  }, [_vm._v(_vm._s(_vm.sellpoint.business_profile))]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "dishes v2"
  }, _vm._l((_vm.products), function(product, prdex) {
    return _c('li', [_c('div', [(product.product_images[0]) ? _c('div', [_c('a', {
      attrs: {
        "href": '/' + _vm.sellpoint.business_username + '/' + product.product_url_name
      }
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": product.product_images[0].product_image,
        "alt": "featured"
      }
    })])]) : _vm._e(), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "cat-con"
    }, [_c('span', [_c('i', [_vm._v(_vm._s(product.product_category_name))])])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(product.product_name))]), _vm._v(" "), _c('p', {
      staticStyle: {
        "height": "40px",
        "overflow": "hidden",
        "text-overflow": "ellipsis"
      }
    }, [_vm._v(_vm._s(product.product_description))]), _vm._v(" "), (product.product_items && (product.product_items.length > 0)) ? _c('p', [_vm._v("₦" + _vm._s(product.product_items[0].product_item_price))]) : _vm._e()])
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "img-nav",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "menu-nav"
    }
  }, [_c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Fast Food and Entrees"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Steak and Chicken"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Pizzas and Calzones"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Sandwiches and Subs"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Drinks and Beverages"
    }
  })]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "tooltip",
    attrs: {
      "href": "#",
      "title": "Sweets and Desserts"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/plus-icon.png",
      "alt": "plus-icon"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Click to enlarge")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-13758c24"}!./src/pages/Sellpoint/Sellpoint/template.html
// module id = 232
// module chunks = 0